import { render, staticRenderFns } from "./home.vue?vue&type=template&id=f9600e46&"
import script from "./home.vue?vue&type=script&lang=babel&"
export * from "./home.vue?vue&type=script&lang=babel&"
import style0 from "./home.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
